<template lang="pug">
ul(class="tl-accordion")
    slot
</template>

<script lang="ts" setup>
import { readonly, reactive, provide } from 'vue'
import { ACCORDION_KEY } from './consts'

const props = withDefaults(defineProps<{
    multi?: boolean
    activeIndex?: string | number
}>(), {
    multi: false,
    activeIndex: '0',
})

const accordion = reactive({
    props: readonly(props),
    state: [] as boolean[],
})

provide(ACCORDION_KEY, accordion)
</script>

<style lang="sass" scoped>
.tl-accordion
    list-style: none
    margin: 0
    padding: 0
</style>
